import { useTranslation } from 'react-i18next';
import * as React from 'react';
import Filter from '../../../../core/components/Filter.tsx';
import { IFilter } from '../../../../core/utils/filterQuery.ts';

interface AgentSenderFilterProps {
    filters: IFilter[];
    onFiltersChange: (filters: IFilter[]) => void;
    senders: string[];
}

const AgentSenderFilter = ({ filters, onFiltersChange, senders }: AgentSenderFilterProps) => {
    const { t } = useTranslation('agents');

    const filter = filters.find((f) => f.name === 'sender');
    const selected = filter ? (Array.isArray(filter.value) ? filter.value : [filter.value]) : [];

    const options = senders.map((sender) => ({ value: sender, label: sender }));

    const handleSelectedChange = (newSelected: string[]) => {
        const newFilters = filters.filter((f) => f.name !== 'sender');
        if (newSelected.length) {
            newFilters.push({ name: 'sender', value: newSelected, exclude: false, expression: 'eq' });
        }
        onFiltersChange(newFilters);
    };

    return (
        <Filter
            allLabel={t('historyPage.filters.sender.all')}
            label={t('historyPage.filters.sender.label')}
            options={options}
            selected={selected}
            onSelectedChange={handleSelectedChange}
            multiple
            showSearch
            showMultipleCount
        />
    );
};

export default AgentSenderFilter;
